<template>
  <div class="redirect-options" :class="{ 'redirect-options--wide': image?.src }">
    <button
      class="redirect-options__close-btn"
      :aria-label="closeBtnAriaLabel"
      @click="handleCloseButtonClick"
    ></button>
    <div v-if="image?.src" class="redirect-options__img-container">
      <img :src="image?.src" alt="" width="400" height="400" />
    </div>
    <div class="redirect-options__content-container">
      <h2 id="ra-redirect-options-title">{{ title }}</h2>
      <p class="redirect-options__content-description">{{ description }}</p>
      <div class="redirect-options__group">
        <select
          id="redirect-countries-select"
          v-model="selectedCountryCode"
          class="redirect-options__countries-select"
          aria-labelledby="ra-redirect-options-title"
        >
          <option
            v-for="(country, index) in countries"
            :key="index"
            :value="country.countryCodes[0]"
          >
            {{ country.name }}
          </option>
        </select>
        <div class="redirect-options__buttons">
          <button
            data-refapp-tagging-target="change-country"
            :data-refapp-tagging-extras="changeCountryTaggingExtras"
            :style="{ backgroundColor: btnBgColor, color: btnTextColor }"
            @click="redirect"
          >
            {{ redirectLabel }}
          </button>
          <button
            data-refapp-tagging-target="continue"
            :style="{ backgroundColor: btnBgColor, color: btnTextColor }"
            @click="handleContinueButtonClick"
          >
            {{ continueLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { redirectOptionsProps } from './props-definitions';
export default {
  name: 'refapp-redirect-options',
  props: redirectOptionsProps,
  data() {
    const selectedCountry = this.findCountryByCode(this.defaultCountryCode) ?? this.countries[0];
    return {
      selectedCountryCode: selectedCountry.countryCodes[0],
    };
  },
  computed: {
    selectedCountry() {
      return this.countries.find(
        (country) =>
          country.countryCodes[0]?.toLowerCase() === this.selectedCountryCode?.toLowerCase(),
      );
    },
    changeCountryTaggingExtras() {
      const countryName = this.selectedCountry?.name.toLowerCase();
      return JSON.stringify({
        eventLabel: countryName,
        event_detail: countryName,
        link_url: this.selectedCountry?.url.toLowerCase(),
      });
    },
  },
  methods: {
    findCountryByCode(code) {
      return this.countries.find((country) =>
        country.countryCodes.some((c) => c.toLowerCase() === code?.toLowerCase()),
      );
    },
    handleCloseButtonClick() {
      this.$emit('close-button-handler');
    },
    handleContinueButtonClick() {
      this.$emit('continue-button-handler');
    },
    redirect() {
      const url = this.selectedCountry.url;
      this.$emit('set-cookie');
      window.location.href = url;
    },
  },
};
</script>
